export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M32 6 L54 14 V30 C54 44 44 54 32 58 C20 54 10 44 10 30 V14 Z" fill="#FFB800" />
    <path d="M32 18 L22 50 H42 Z" fill="#0A0D12" />
    <path d="M32 24 V29 M32 34 V39 M32 44 V49" stroke="#FFB800" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className="text-left leading-none">
      <span className="block font-display text-2xl font-extrabold uppercase tracking-wide text-bone">ShieldTeen</span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-mist">by Hunt Shield Insurance</span>
    </span>
  </span>
);
